import { Link } from "react-router";
import { Pages } from "../../../utils";
import { HERO_STATS } from "../data";
import { AccessOfferLink } from "./AccessOfferLink";
import { StatRow } from "./StatRow";

export const HeroSection = () => {
  return (
    <section className="hero">
      <div className="hero-left">
        <p className="hero-eyebrow">Home Design Guild - Exclusive Offer</p>
        <h1>
          Give your clients <em>the freedom</em> to say yes.
        </h1>
        <p className="hero-body">
          Six out of ten homeowners seeking interior design services want the
          option to finance their project. By offering financing through your
          practice, you eliminate budget hesitation and invite clients to invest
          at the level their vision truly deserves.
        </p>
        <div className="hero-cta-group">
          <AccessOfferLink className="btn-primary">
            Log In to Access the Offer
          </AccessOfferLink>
          <Link to={Pages.SIGNUP} className="btn-secondary">
            New to Home Design Guild? Create a Free Account
          </Link>
        </div>
      </div>

      <div className="hero-stats">
        {HERO_STATS.map((item) => (
          <StatRow key={item.value} item={item} />
        ))}
      </div>
    </section>
  );
};
